export default __webpack_public_path__ + "static/media/gallery_00.f0cbbb9d.jpg";